export function sanitizeChannelProps (channel) {
  // remove .00 from props that contains numbers or strings with number values and conver to string since .00 has removed
  const props = [
    'budget',
    'max_bid',
    'target_cpa',
    'target_roas'
  ]
  props.forEach(prop => {
    if (channel[prop]) {
      channel[prop] = channel[prop].toString().replace('.00', '')
    }
  })
  return channel
}
